<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <FullCalendar :options="calendarOptions">
          <template v-slot:eventContent="arg">
            <b>
              {{
                arg.event.extendedProps.tipoCita === "enturne"
                  ? "Cita Turne"
                  : "Cita Cargue"
              }}
            </b>
            <br />
            <i>{{ arg.event.extendedProps.nTipoRuta }} | </i>
            <i>{{ arg.event.extendedProps.producto }} | </i>
            <i>{{ arg.event.extendedProps.cargues }} Cargues</i>
          </template>
        </FullCalendar>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listGridPlugin from "@fullcalendar/list";
import esLocale from "@fullcalendar/core/locales/es";
import axios from "axios";
export default {
  components: {
    FullCalendar,
  },

  data() {
    return {
      calendarOptions: {
        plugins: [listGridPlugin, interactionPlugin, timeGridPlugin],
        initialDate: new Date(this.$parent.form.fecha),
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "timeGridDay,listDay",
        },
        initialView: "timeGridDay",
        locale: esLocale,
        height: 350,
        events: [],
        eventClick: (clickInfo) => this.verDet(clickInfo),
      },
    };
  },

  methods: {
    formatDate(dateValue) {
      if (!dateValue) {
        return "";
      }
      return new Intl.DateTimeFormat("es-ES", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(dateValue));
    },

    getEvents() {
      this.$parent.cargando = true;
      let idSolicitud = this.$parent.form.id;
      axios
        .get(
          "/api/hidrocarburos/solicitudes/detSolicitud/calendar/" + idSolicitud,
          {}
        )
        .then((response) => {
          this.calendarOptions.events = response.data;
          this.$parent.cargando = false;
        })
        .catch((error) => {
          this.$parent.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    verDet(clickInfo) {
      console.log(clickInfo.event.extendedProps);
      const isEnturne = clickInfo.event.extendedProps.tipoCita === "enturne";
      this.$swal({
        icon: "info",
        title: isEnturne
          ? `Cita Turne: ${clickInfo.event.extendedProps.citaEnturne}`
          : `Cita Cargue: ${clickInfo.event.extendedProps.citaCampo}`,
        html: `
            <p><b>${isEnturne ? "Fecha Cargue" : "Fecha Turne"}:</b> ${
          isEnturne
            ? clickInfo.event.extendedProps.citaCampo
              ? clickInfo.event.extendedProps.citaCampo
              : "Sin definir"
            : clickInfo.event.extendedProps.citaEnturne
            ? clickInfo.event.extendedProps.citaEnturne
            : "Sin definir"
        }</p>
            <p><b>Empresa:</b> ${clickInfo.event.extendedProps.empresa}</p>
            <p><b>Tipo Ruta:</b> ${clickInfo.event.extendedProps.nTipoRuta}</p>
            <p><b>Tipo Producto:</b> ${
              clickInfo.event.extendedProps.producto
            }</p>
            <p><b>Destino</b> ${clickInfo.event.extendedProps.nDestion}</p>
            <p><b>Cargues:</b> ${clickInfo.event.extendedProps.cargues}</p>
            <p><b>Turno:</b> ${clickInfo.event.extendedProps.turno}`,
      });
    },
  },
  created() {
    this.getEvents();
  },
};
</script>

<style>
.fc-toolbar,
.fc-toolbar.fc-header-toolbar {
  padding: 0px;
}
.fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 1px;
}
</style>
